import { ICON_SELECTOR } from '@/enum/Selectors'
import { syncReadingGuideHeight } from './readingGuide'

const FONT_SIZE_SELECTOR = 'h1,h2,h3,h4,h5,h6,p,a,dl,dt,li,ol,th,td,span,blockquote,.asw-text'
const ICON_SELECTOR_SET = new Set(ICON_SELECTOR)

function isInsideWidget(el: Element): boolean {
  return el.closest('.asw-container, .asw-rg-container') !== null
}

export default function adjustFontSize(multiply: number = 1) {
  // Prevent floating point accumulation
  const roundedMultiply = Number(multiply.toFixed(2))
  // Publish the multiplier so other tools (e.g. reading guide) can react
  // without us threading state through them.
  ;(globalThis as { __asw__fontSize?: number }).__asw__fontSize = roundedMultiply
  syncReadingGuideHeight()
  document.querySelectorAll<HTMLElement>(FONT_SIZE_SELECTOR).forEach((el) => {
    if ([...el.classList].some((cls) => ICON_SELECTOR_SET.has(cls))) return
    if (el.id?.startsWith('asw-')) return
    if (isInsideWidget(el)) return

    // On reset, fully remove all widget overrides
    if (roundedMultiply === 1) {
      if (el.dataset.aswFontApplied) {
        el.style.fontSize = ''
        el.style.lineHeight = ''
        el.style.textWrap = ''
        delete el.dataset.aswFontApplied
      }
      // Also clear original cache so re-adjust starts fresh
      delete el.dataset.aswFontOriginal
      return
    }

    // Use cached original font-size if already computed once
    // This avoids recomputing from CSS which may differ due to
    // responsive breakpoints, media queries, or DOM context changes
    const cached = el.dataset.aswFontApplied
    const cachedOriginal = el.dataset.aswFontOriginal

    let originalPx: number
    if (cachedOriginal) {
      originalPx = Number(cachedOriginal)
    } else {
      // First time: strip any leftover inline font-size, compute, cache it
      el.style.fontSize = ''
      originalPx = Number.parseInt(window.getComputedStyle(el).fontSize, 10)
      if (!Number.isFinite(originalPx)) return
      el.dataset.aswFontOriginal = String(originalPx)
    }

    // Skip if already adjusted at the current multiply
    if (cached === String(roundedMultiply)) return

    const newFontSize = Math.round(originalPx * roundedMultiply)
    el.style.fontSize = `${newFontSize}px`
    el.style.lineHeight = 'unset'
    el.style.textWrap = 'auto'
    el.dataset.aswFontApplied = String(roundedMultiply)
  })
}
